import { useStytch, useStytchUser } from "@stytch/react";
import { useMutation } from "@tanstack/react-query";
import { useAuthCancel, useAuthContinue } from "features/auth/AuthUtils";
import {
  AuthPasswordCreateForm,
  AuthPasswordCreateFormData,
} from "features/auth/password/AuthPasswordCreateForm";
import {
  getStytchSessionDurationMinutes,
  useStytchToken,
} from "features/auth/StytchUtils";
import React from "react";

export const AuthPasswordResetPage: React.FC = () => {
  const token = useStytchToken();
  const stytchClient = useStytch();
  const stytchUser = useStytchUser();

  const authContinue = useAuthContinue();
  const authCancel = useAuthCancel();

  const { mutateAsync: resetPassword, isPending } = useMutation({
    mutationFn: ({ password }: AuthPasswordCreateFormData) =>
      stytchClient.passwords.resetByEmail({
        password,
        token,
        session_duration_minutes: getStytchSessionDurationMinutes(),
      }),
  });

  return (
    <AuthPasswordCreateForm
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      email={stytchUser.user?.emails?.[0]?.email}
      onSubmit={resetPassword}
      onSuccess={authContinue}
      onCancel={authCancel}
      isLoading={isPending}
    />
  );
};
